import React, { useState, useEffect } from "react";
import { string } from "prop-types";
import { Popover, ArrowContainer } from "react-tiny-popover";
import "./popover-element.m.css";
import { updateUserFlag } from "../../../hook/update-user-flag";

export const PopoverElement = ({ anchor, user_flag, showContents = true }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [seuraamaniAiheetUrl, setSeuraamaniAiheetUrl] = useState("https://ilkkapohjalainen.fi/seuraamani-aiheet");
  const [tallentamaniArtikkelitUrl, setTallentamaniArtikkelitUrl] = useState("https://ilkkapohjalainen.fi/tallentamani-artikkelit");
  let popoverContentMaxWidth = '200px';

  useEffect(() => {
    if (typeof window === 'undefined') { }
    else {
      if (window.location.href.indexOf("localhost") > -1) {
        setSeuraamaniAiheetUrl("http://localhost:3000/seuraamani-aiheet")
        setTallentamaniArtikkelitUrl("http://localhost:3000/tallentamani-artikkelit")
      } else if (window.location.href.indexOf("qtstage") > -1) {
        setSeuraamaniAiheetUrl("https://imediat-web.fiare.qtstage.io/seuraamani-aiheet")
        setTallentamaniArtikkelitUrl("https://imediat-web.fiare.qtstage.io/tallentamani-artikkelit")
      } else {
        setSeuraamaniAiheetUrl("https://ilkkapohjalainen.fi/seuraamani-aiheet")
        setTallentamaniArtikkelitUrl("https://ilkkapohjalainen.fi/tallentamani-artikkelit")
      }
    }
  }, [])

  const openBookmarkPopover = async () => {
    const checkBMorTag = user_flag === "bm_user_flag" ? "has_bookmarked_stories" : user_flag === "tag_user_flag" ? "has_followed_tags" : "";
    if (typeof window === 'undefined') {
      return;
    } else {
      const response = checkBMorTag && await fetch(`/profile/flag/getByName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ flag_name: checkBMorTag }),
      });
      const jsonResponse = response && await response.json();
      if (jsonResponse.data == "1") {
        setIsPopoverOpen(false);
      } else {
        setIsPopoverOpen(true)
        user_flag && updateUserFlag(user_flag)
      }
    }
  };

  const openInformationPopover = () => {
    setIsPopoverOpen(!isPopoverOpen);
  }

  const setAnchor = () => {
    switch (anchor) {
      case "ri-bookmark-line":
        return (
          <i className={`ri-bookmark-line`} onClick={() => openBookmarkPopover()} styleName="bookmark-line"></i>
        )
      case "ri-bookmark-fill":
        return (
          <i className={`ri-bookmark-fill`} onClick={() => openBookmarkPopover()} styleName="bookmark-fill"></i>
        )
      case "ri-add-line":
        return (
          <i className={`ri-add-line`} onClick={() => openBookmarkPopover()}></i>
        )
      case "ri-check-line":
        return (
          <i className={`ri-check-line`} onClick={() => openBookmarkPopover()}></i>
        )
      case "follow-ri-add-line":
        return (
          <div styleName="follow-ri-add-line-container" onClick={() => openBookmarkPopover()}>SEURAA <i className={`ri-add-line`}></i></div>
        )
      case "follow-ri-check-line":
        return (
          <div styleName="follow-ri-check-line-container" onClick={() => openBookmarkPopover()}>SEURAA <i className={`ri-check-line`}></i></div>
        )
      case "ri-information-line":
        popoverContentMaxWidth = '400px';
        return (
          <i className={`ri-information-line`} styleName="information-line" onClick={() => openInformationPopover()}></i>
        )
      default:
        break;
    }
  }

  const setContent = () => {
    switch (anchor) {
      case "ri-bookmark-fill":
        return (
          <>Tallensit artikkelin. Voit hallinnoida tallentamiasi artikkeleita <a href={tallentamaniArtikkelitUrl}>Tallentamani artikkelit -sivulta</a>, josta löydät myös lisätietoa.</>
        )
      case "ri-check-line":
        return (
          <>Seuraat aihetta. Voit hallinnoida seuraamiasi aiheita <a href={seuraamaniAiheetUrl}>Seuraamani aiheet -sivulta</a>, josta löydät myös lisätietoa.</>
        )
      case "follow-ri-check-line":
        return (
          <>Seuraat aihetta. Voit hallinnoida seuraamiasi aiheita <a href={seuraamaniAiheetUrl}>Seuraamani aiheet -sivulta</a>, josta löydät myös lisätietoa.</>
        )
      case "ri-information-line":
        return (
          <>
            <div styleName="ri-information-line-desktop">
              Sivun oikeassa reunassa näet seuraamasi aiheet. Pääset lukemaan pelkästään haluamaasi aiheeseen liittyviä juttuja aiheen nimeä painamalla.<br /><br />
              Voit lopettaa aiheen seuraamisen painamalla <i className="ri-check-line"></i>-ikonia tai voit lopettaa kaikkien aiheiden seuraamisen painikkeesta "Lopeta kaikkien seuraaminen".
            </div>
            <div styleName="ri-information-line-mobile">
              "Näytä seuraamani aiheet" -otsikkoa klikkaamalla näet listan seuraamistasi aiheista. Pääset lukemaan pelkästään haluamaasi aiheeseen liittyviä juttuja aiheen nimeä painamalla.<br /><br />
              Voit lopettaa aiheen seuraamisen painamalla <i className="ri-check-line"></i>-ikonia tai voit lopettaa kaikkien aiheiden seuraamisen painikkeesta "Lopeta kaikkien seuraaminen".
            </div>
          </>
        )
      default:
        break;
    }
  }

  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={['bottom', 'right', 'left', 'top']}
      containerStyle={{ zIndex: '1' }}
      onRequestClose={() => setIsPopoverOpen(false)}
      onClickOutside={() => setIsPopoverOpen(false)}
      content={({ position, childRect, popoverRect }) => (
        showContents ? <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor={'#525252'}
          arrowSize={10}
          arrowStyle={{ opacity: 1.0 }}
          className='popover-arrow-container'
          arrowClassName='popover-arrow'
        >
          <div styleName="popover-content" style={{ maxWidth: popoverContentMaxWidth }} onClick={(e) => { e.stopPropagation(); }}>
            <span styleName="popover-text">{setContent()}</span>
            <button styleName="popover-ok" onClick={() => setIsPopoverOpen(false)}>OK</button>
          </div>
        </ArrowContainer> : null
      )}
    >
      {setAnchor()}
    </Popover>
  );
};

PopoverElement.propTypes = {
  anchor: string,
  user_flag: string
};
